// TableBody.jsx

import React from 'react';

// CSS
import './TableBody.css';

// Components
import TableRow from 'views/table/components/TableRow';

/**
 * TableBody
 *
 * @returns {ReactNode} The rendered component.
 */
const TableBody = ({
    nodes,
    columns,
    schemaFieldMap,
    fieldDataSection,
    editingCell,
    editingValue,
    setEditingValue,
    handleCommitEdit,
    handleCancelEdit,
    handleCellActivate,
    handleOpenNode,
    onNodeChange = null,
    typeKey = '',
    selectedKeys,
    onToggleSelect,
    showCheckboxes,
    language,
    resolveNodelistTitle,
    nodeDragEnabled = false,
    onNodeDragStart = null,
}) => {

  // ----- RENDER ----- //

  return (
    <div className="table-view-body">
        {nodes.map((node) => (
            <TableRow
              key={node?.key}
              node={node}
              columns={columns}
              schemaFieldMap={schemaFieldMap}
              fieldDataSection={fieldDataSection}
              editingCell={editingCell}
              editingValue={editingValue}
              setEditingValue={setEditingValue}
              handleCommitEdit={handleCommitEdit}
              handleCancelEdit={handleCancelEdit}
              handleCellActivate={handleCellActivate}
              handleOpenNode={handleOpenNode}
              onNodeChange={onNodeChange}
              typeKey={typeKey}
              selectedKeys={selectedKeys}
              showCheckboxes={showCheckboxes}
              language={language}
              resolveNodelistTitle={resolveNodelistTitle}
              onToggleSelect={onToggleSelect}
              draggable={nodeDragEnabled && Boolean(node?.key)}
              onDragStart={onNodeDragStart
                ? (event) => onNodeDragStart(event, node)
                : undefined}
            />
        ))}
    </div>
);
};

// Dev Tools
TableBody.displayName = 'TableBody';

export default TableBody;
